import Vue from 'vue'

/**
 * EventBus Plugin for Vue
 */
const eventBus = {

  $eventBus: null,

  install (vue, options) {
    this.$eventBus = new Vue();
    vue.prototype.$eventBus = this;
    // Object.defineProperty(vue.prototype, '$bus', this);
  },

  listen (module, event, handler=null, forceModule=false) {
    if (handler) {
      this.$eventBus.$on(this.__module(module, forceModule) + this.__event(event), handler)
    }else{
      this.$eventBus.$on(this.__module(module, forceModule) + this.__event(event))
    }
  },

  listenOnce (module, event, handler=null) {
    this.$eventBus.$once(this.__module(module) + this.__event(event), handler)
  },

  remove (module, event, handler=null, forceModule=false) {
    if (handler) {
      this.$eventBus.$off(this.__module(module, forceModule) + this.__event(event), handler)
    } else {
      this.$eventBus.$off(this.__module(module, forceModule) + this.__event(event))
    }
  },

  removeAll () {
    this.$eventBus.$off()
  },

  publish (module, event, handler=null, forceModule=false) {
    if (handler) {
      this.$eventBus.$emit(this.__module(module, forceModule) + this.__event(event), handler)
    }else{
      this.$eventBus.$emit(this.__module(module, forceModule) + this.__event(event))
    }
  },

  __module (module, forceModule=false) {
    // return (module ? (module.toLowerCase() + ':') : '');
    return forceModule ? (module ? (module.toLowerCase() + ':') : '') : '';
  },

  __event (event) {
    return event.toLowerCase();
  }
};

Vue.use(eventBus);